import {
  LOAD_NOTIFICATIONS,
  LOAD_NOTIFICATIONS_SUCCESS,
  TOGGLE_NOTIFICATION_DRAWER,
  TOGGLE_TASK_VIEW,
  VIEW_NOTIFICATION,
  VIEW_NOTIFICATION_SUCCESS,
  VIEW_ALL_NOTIFICATION,
  VIEW_ALL_NOTIFICATION_SUCCESS,
  CHANGE_NOTIFICATION_FILTERS,
  DELETE_NOTIFICATION,
  DELETE_NOTIFICATION_SUCCESS,
  LOAD_TASKS,
  LOAD_DRAWER_TASKS_SUCCESS,
  APPEND_NEW_FEED,
  SUBSCRIBE_NEW_FEED,
  UNSUBSCRIBE_NEW_FEED,
} from 'constants/ActionTypes';
import { getIntlMessage } from 'helpers/utilHelpers';
import { getNotificationFilters } from 'selectors/ui/notificationDrawerSelectors';
import { getSortingByKey } from 'selectors/settingsSelectors';
import { NOTIFICATION_PANEL, NOTIFICATION_TASK_PANEL } from 'constants/SettingConstants';
import { fromJS } from 'immutable';

// Handles opening/closing of the drawer
export const toggleNotificationDrawer = () => {
  return { type: TOGGLE_NOTIFICATION_DRAWER };
};

// Handles notifications loading
export const loadNotifications = (payload = {}) => {
  return {
    type: LOAD_NOTIFICATIONS,
    payload: {
      resource: 'feed',
      extraFields: ['relatedEntity'],
      onSuccess: loadNotificationsSuccess,
      onErrorMessage: getIntlMessage('notifications.load.error'),
      filters: {
        new: {
          selector: getNotificationFilters,
          key: 'new',
        },
        mention: {
          selector: getNotificationFilters,
          key: 'mention',
        },
        task: {
          selector: getNotificationFilters,
          key: 'task',
        },
        project: {
          selector: getNotificationFilters,
          key: 'project',
        },
        comment: {
          selector: getNotificationFilters,
          key: 'comment',
        },
        monitoring: {
          selector: getNotificationFilters,
          key: 'monitoring',
        },
      },
      ...payload,
    },
  };
};
const loadNotificationsSuccess = (notifications) => {
  return {
    type: LOAD_NOTIFICATIONS_SUCCESS,
    notifications,
  };
};

// Handles marking of a notification as viewed
export const viewNotification = (notificationId, payload = {}, isUnread = false) => {
  return {
    type: VIEW_NOTIFICATION,
    payload: {
      resource: 'feed',
      entityPrimaryKey: 'feedId',
      onSuccess: viewNotificationSuccess,
      onErrorMessage: getIntlMessage('notifications.view.error'),
      ...payload,
    },
    values: {
      feedId: notificationId,
      isUnread,
    },
  };
};
const viewNotificationSuccess = (notification) => {
  return {
    type: VIEW_NOTIFICATION_SUCCESS,
    notification,
  };
};

// Handles marking of all notifications as viewed
export const viewAllNotification = (payload = {}) => {
  return {
    type: VIEW_ALL_NOTIFICATION,
    payload: {
      resource: 'feed/view-all',
      onSuccess: viewAllNotificationSuccess,
      onErrorMessage: getIntlMessage('notifications.view.error'),
      ...payload,
    },
  };
};
const viewAllNotificationSuccess = () => {
  return {
    type: VIEW_ALL_NOTIFICATION_SUCCESS,
  };
};

// Handles opening and closing of the task view modal
export const toggleTaskView = (taskId = null, commentId = null, inProject = false) => {
  return {
    type: TOGGLE_TASK_VIEW,
    taskId,
    commentId,
    inProject,
  };
};

export const changeNotificationFilters = (filters) => {
  return {
    type: CHANGE_NOTIFICATION_FILTERS,
    filters,
  };
};

export const deleteNotification = (feedId) => {
  return {
    type: DELETE_NOTIFICATION,
    payload: {
      resource: 'feed',
      entityId: feedId,
      onSuccess: deleteNotificationSuccess,
    },
  };
};

export const deleteNotificationSuccess = (feedId) => {
  return {
    type: DELETE_NOTIFICATION_SUCCESS,
    feedId,
  };
};

export const loadDrawerTasks = (payload = {}) => {
  return {
    type: LOAD_TASKS,
    payload: {
      resource: 'tasks',
      extraFields: ['privacyUsers'],
      onSuccess: (response) => loadDrawerTaskSuccess(response, true),
      onErrorMessage: getIntlMessage('task.load.error'),
      ...payload,
      filters: {
        search: {
          value: payload.search,
        },
        userTasks: {
          value: true,
        },
        notArchived: {
          value: true,
        },
        status: {
          value: 'active',
        },
      },
      sort: (state) => {
        let sorting = getSortingByKey(state, { settingKey: `${NOTIFICATION_PANEL}.${NOTIFICATION_TASK_PANEL}` });
        if (!sorting) {
          return;
        }
        sorting.forEach((value, key) => {
          if (value) {
            if (key.indexOf('priority') !== -1) {
              sorting = fromJS([
                { key: 'endDate', value: 'descending' },
                { key, value },
              ]);
              return;
            }
            sorting = fromJS({ key, value });
            return;
          }
        });

        return sorting;
      },
    },
  };
};

// Update tasks if loading is succeed
export const loadDrawerTaskSuccess = (tasks, saveIds = false) => {
  return {
    type: LOAD_DRAWER_TASKS_SUCCESS,
    tasks,
    saveIds,
  };
};

// Subscribes to the `newFeed` event in websocket
export const subscribeNewFeed = () => {
  return {
    type: SUBSCRIBE_NEW_FEED,
  };
};

// Unsubscribes from the `newFeed` event in websocket
export const unsubscribeNewFeed = () => {
  return {
    type: UNSUBSCRIBE_NEW_FEED,
  };
};

export const appendNewFeedSocket = (feed) => {
  return {
    type: APPEND_NEW_FEED,
    payload: feed,
  };
};
